<template>
  <h1 class="text-3xl font-bold sm:text-left text-center text-blue pader">
    Try a Quick Play
  </h1>

  <div class="grid grid-cols-1 md:grid-cols-2 md:gap-12 lg:gap-[115px] pader">
    <div class="sm:py-4 pb-8 pt-4 text-lef">
      <div>
        <p class="text-base sm:text-left text-center">
          You have to choose 07 numbers from a set of 35.
        </p>
        <p class="text-base sm:text-left text-center">
          It is totally up to you which number you choose, you can also choose a
          powerball number from 1 to 20.
        </p>
      </div>
    </div>


  </div>
</template>

<script>
export default {
  name: "QuickPlay",
};
</script>

<style scoped></style>
